import { Check, Close } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { IconButton, Tooltip } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import useEditableCurrencyCell from "../../hooks/useEditableCurrencyCell";
import { SETTLEMENT_STYLES } from "../../style/styles";

export default function EditableCurrencyCell({ detail, fieldKey, value, onSaveSuccess, canEdit }) {
  const {
    draftValue,
    isEditing,
    isSaving,
    canEditMedicalBreakdown,
    handleCancel,
    handleChange,
    handleEdit,
    handleSave,
  } = useEditableCurrencyCell({ detail, fieldKey, value, onSaveSuccess });

  if (!isEditing) {
    const displayValue =
      draftValue === "" || draftValue === null ? "-" : `$${draftValue}`;
    const valueDisplay = (
      <span className="min-w-0 flex-1 truncate text-center">{displayValue}</span>
    );

    return (
      <div className="flex min-h-[36px] w-full items-center justify-center gap-1">
        {displayValue === "-" ? (
          valueDisplay
        ) : (
          <Tooltip title={displayValue} placement="top" arrow>
            {valueDisplay}
          </Tooltip>
        )}
        {canEdit && canEditMedicalBreakdown ? (
          <Tooltip title="Edit Reduced To">
            <span className="flex-none">
              <IconButton
                size="small"
                onClick={handleEdit}
                sx={SETTLEMENT_STYLES.editableIconButton}
              >
                <EditOutlinedIcon sx={SETTLEMENT_STYLES.editableIcon} />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
      </div>
    );
  }

  return (
    <div className="w-full">
      <div
        className="flex w-full items-center rounded-[8px] border px-2 py-2"
        style={{ borderColor: HNSColors.neutrals[400], backgroundColor: HNSColors.neutrals[900] }}
      >
        <span className="mr-1 flex-none" style={{ color: HNSColors.neutrals[600] }}>$</span>
        <input
          id={`reduced-to-${detail?.pk || detail?.id || "row"}`}
          className="min-w-0 flex-1 bg-transparent text-sm outline-none"
          value={draftValue}
          onChange={handleChange}
          disabled={isSaving}
          autoFocus
          style={{ color: HNSColors.neutrals[100] }}
        />
        <div className="ml-1 flex flex-none items-center">
          <IconButton edge="end" size="small" onClick={handleSave} disabled={isSaving}>
            <Check sx={SETTLEMENT_STYLES.editableSuccessIcon} />
          </IconButton>
          <IconButton edge="end" size="small" onClick={handleCancel} disabled={isSaving}>
            <Close sx={SETTLEMENT_STYLES.editableFailureIcon} />
          </IconButton>
        </div>
      </div>
    </div>
  );
}
